<template>
  <DynamicText
    tag="span"
    styleGroup="Stake Amount"
    :get="stakeFont.get"
    :set="stakeFont.set"
    :class="[classes.stake, classes.stakeTextBase]"
  >
    <div :class="[classes.stakeLabel]">
      {{ betText }}
    </div>
    <div :class="[classes.stakeAmount]">
      {{ stake }}
    </div>
  </DynamicText>
</template>

<script lang="ts">
import { createUseStyles } from "@fresh8/vue-jss/src";
import { defineComponent } from "vue";
import DynamicText from "../../DynamicText.vue";
import { Brand } from "@fresh8/types/src";
import { getTranslation } from "@fresh8/ad-data-composition/src/lang";
import { useStake } from "@fresh8/ad-data-composition/src/usePotentialWinnings";

const useStyles = createUseStyles({
  stake: {
    marginRight: "4px",
    minWidth: "33%",
    maxWidth: "40%",
    color: "white"
  },
  stakeTextBase: {
    color: "#142E5D"
  },
  stakeLabel: {
    fontSize: "9px",
    lineHeight: "10px"
  },
  stakeAmount: {
    fontSize: "16px",
    lineHeight: "18px"
  }
});

export default defineComponent({
  name: "StakeAmount",
  components: {
    DynamicText
  },
  setup() {
    return {
      classes: useStyles(),
      stakeFont: {
        get(brand: Brand) {
          return brand.adTemplate.parlayCard?.stakeFont || "";
        },
        set(brand: Brand, value: string) {
          if (brand.adTemplate.parlayCard)
            brand.adTemplate.parlayCard.stakeFont = value;
        }
      },
      betText: getTranslation(window.navigator.language.toLowerCase())
        .ParlayTexts.Stake,
      stake: useStake().formattedStake
    };
  }
});
</script>
